import { render } from "./HistoriaClinicaKid.vue?vue&type=template&id=3e5ee40e&scoped=true"
import script from "./HistoriaClinicaKid.vue?vue&type=script&lang=js"
export * from "./HistoriaClinicaKid.vue?vue&type=script&lang=js"

import "./HistoriaClinicaKid.vue?vue&type=style&index=0&id=3e5ee40e&lang=scss&scoped=true"

import exportComponent from "C:\\laragon\\www\\fronted_sit_bolivia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e5ee40e"]])

export default __exports__